<template>
<loader v-bind="{ loading }">
    <columns>
      <column>
        <text-input v-model="filters.search" classes="is-rounded">
          <template #right>
            <div class="buttons has-addons is-rounded">
              <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
                <icon icon="times"/>
              </action-button>
              <action-button @click="runFilters" class="is-rounded">
                <icon icon="search"/>
                <span>Search</span>
              </action-button>
            </div>
          </template>
        </text-input>
      </column>
      <column class="is-narrow is-flex align-end">
        <router-link 
          class="button is-small is-rounded"
          :to="{
            name: 'new-standard'
          }">
          <icon icon="plus"/>
          <span>Standard</span>
        </router-link>
      </column>
    </columns>

    <div>
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Name</th>
              <th>Sections</th>
              <th>Checkpoints</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="standard in standards.data" :key="standard.id">
              <td>
                <router-link
                  :to="{
                    name: 'standard-manager',
                    params: {
                      standard: standard.id
                    }
                  }">
                  {{ standard.name }}
                </router-link>
              </td>
              <td>
                {{ standard.sections.length || 0 }}
              </td>
              <td>
                {{ checkpointsCount(standard.sections) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Standards',

  data: () => ({
    standards: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadStandards()
  },

  methods: {
    loadStandards() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.standards = data
        this.loading = false
      }, error => {
        this.loading = false
      })
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'standards',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'standards',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    },
    checkpointsCount(sections) {
      return sections.reduce((total, section) => {
        return total + section.checkpoints.length
      }, 0)
    }
  },

  watch: {
    '$route': 'loadStandards'
  }

}
</script>
